angular
  .module("myApp")

  .controller("ExpertApplicationController", function ($scope, $state, uuiData) {
    this.navigate = (r) => {
      $state.go("app.expert-application.edit", {
        id: r.pd_versija_id,
        ekspertize_id: r.id,
      })
    }
    $scope.applications = []
    uuiData.list(
      "petniecibas_pieteikums_expert_list",
      (ns) => {
        $scope.applications = ns.map((n) => {
          const is_complete = n.e_statuss === "IESNIEGTS" && n.konsolid_statuss === "IESNIEGTS"
          let needs_immediate_action = false
          if (n.e_statuss !== "IESNIEGTS") needs_immediate_action = true
          if (n.e_ir_konsolidetajs && n.e_statuss === "IESNIEGTS") {
            if (n.konsolid_statuss !== "IESNIEGTS") {
              // needs_immediate_action = vai visi iesnieguši?
            }
          }
          return {
            ...n,
            needs_immediate_action,
            is_complete,
          }
        })
      },
      $scope.failing
    )
    $scope.status_translation = {
      MELNRAKSTS: "In progress",
      IESNIEDZAMS: "Saved",
      IESNIEGTS: "Completed",
    }
    $scope.cons_translation = {
      MELNRAKSTS: "Consolidation in progress",
      IESNIEDZAMS: "Consolidation in progress",
      IESNIEGTS: "Completed",
    }
  })

  .controller(
    "ExpertApplicationFormController",
    function (
      uuiData,
      $http,
      $scope,
      $stateParams,
      Notification,
      Codifiers,
      PpExpertEvaluation,
      PpExpertConsolidation,
      $rootScope,
      Dialog,
      $timeout
    ) {
      $scope.dto = undefined
      $scope.me = undefined
      $scope.consolidated = {}

      $scope.rate = {
        YES: "Complies",
        NO: "Does not comply",
        COND: "Complies, with recommendations",
      }

      $scope.cons = {
        excellence_score: 0.0,
        impact_score: 0.0,
        implementation_score: 0.0,
        category_score: 0.0,
        excellence_rated: "",
        impact_rated: "",
        implementation_rated: "",
        overall_rated: "",
        category_rated: "",
      }

      $scope.kla = Codifiers.kla
      $scope.editable = false
      $scope.submittable = false
      $scope.cons_editable = false
      $scope.cons_submittable = false

      $scope.slider_opts = {
        floor: 0,
        ceil: 5.0,
        step: 0.2,
        precision: 1,
        showSelectionBar: true,
        showTicks: 1,
      }

      this.tabs = [
        {
          name: "files",
          visible: true,
          section: "",
          head: "Files",
          template: "pages/pp/tab-expert-files.html",
        },
        {
          visible: true,
          section: "",
          head: "Your evaluation",
          template: "pages/pp/tab-expert-individual.html",
        },
        {
          name: "cons",
          visible: false,
          section: "",
          head: "Consolidated evaluation",
          template: "pages/pp/tab-expert-consolidated.html",
        },
        {
          name: "review",
          visible: false,
          section: "",
          head: "Consolidated review",
          template: "pages/pp/tab-expert-consolidated-review.html",
        },
      ]

      this.tabEnter = () => {
        $timeout(() => {
          $scope.$broadcast("rzSliderForceRender")
        })
      }

      this.active_tab = $stateParams.page ? +$stateParams.page : 0

      $scope.reloadMe = () => {
        // $scope.me.$promise.catch($scope.failing)

        $scope.sections = []

        uuiData.record("pp_expert_evaluation", $stateParams.ekspertize_id).$promise.then((me) => {
          $scope.me = me

          $scope.sections = Codifiers.expert_sections.filter((s) => s.types.includes(me.veids))

          $scope.editable = true
          $scope.submittable = false

          if (me.statuss === "IESNIEGTS") {
            $scope.editable = false
            $scope.submittable = false
          }
          if (me.statuss === "IESNIEDZAMS") {
            $scope.editable = true
            $scope.submittable = true
          }

          $scope.consolidated = uuiData.record("pp_expert_consolidation_data", $stateParams.ekspertize_id)
          $scope.consolidated.$promise.then((c) => {
            let found = false
            c.vertejums.forEach((e) => {
              if (!e.eksperts_id) {
                found = true
                $scope.cons = e

                if (me.veids === "FINAL") {
                  e.excellence_score = Number.isNaN(e.excellence_score) ? null : +e.excellence_score
                  e.impact_score = Number.isNaN(e.impact_score) ? null : +e.impact_score
                  e.implementation_score = Number.isNaN(e.implementation_score)
                    ? null
                    : +e.implementation_score
                } else {
                  e.excellence_score = Number.isNaN(e.excellence_score) ? 0.0 : +e.excellence_score
                  e.impact_score = Number.isNaN(e.impact_score) ? 0.0 : +e.impact_score
                  e.implementation_score = Number.isNaN(e.implementation_score)
                    ? 0.0
                    : +e.implementation_score
                  e.category_score = Number.isNaN(e.category_score) ? 0.0 : +e.category_score
                }
              }
            })

            const all_done = !_.find(c.eksperts, (n) => n.statuss !== "IESNIEGTS")

            const ir_konsolidetajs = c.eksperts.find(
              (e) => e.eksperts_id === $rootScope.u.id
            ).ir_konsolidetajs
            $scope.ir_konsolidetajs = ir_konsolidetajs

            if (ir_konsolidetajs) {
              this.tabs.find((t) => t.name === "cons").visible = true
            }

            {
              // fiksējam review_tabu
              const review_tab = this.tabs.find((t) => t.name === "review")
              const cons_tab = this.tabs.find((t) => t.name === "cons")

              review_tab.visible = false
              review_tab.marked = false

              if (c.konsolid_statuss === "SASKANOSANA" && !ir_konsolidetajs) {
                review_tab.visible = true
                review_tab.marked = true
              }
              if (c.konsolid_statuss === "SASKANOSANA" && ir_konsolidetajs) {
                cons_tab.visible = false
                review_tab.visible = true
                review_tab.marked = true
              }

              if (c.konsolid_statuss === "AKCEPTETS" && !ir_konsolidetajs) {
                review_tab.visible = true
              }
              if (c.konsolid_statuss === "AKCEPTETS" && ir_konsolidetajs) {
                cons_tab.visible = true
              }
              if (c.konsolid_statuss === "IESNIEDZAMS" && ir_konsolidetajs) {
                cons_tab.marked = true
              }
              if (c.konsolid_statuss === "NORAIDITS" && ir_konsolidetajs) {
                cons_tab.marked = true
              }
            }

            if (!found && me.veids === "FINAL") {
              $scope.cons.excellence_score = null
              $scope.cons.impact_score = null
              $scope.cons.implementation_score = null
              $scope.cons.overall_score = null
            }

            if (
              _.find(c.eksperts, {
                ir_lietotajs: true,
                ir_konsolidetajs: true,
              })
            ) {
              $scope.cons_submittable = false
              $scope.cons_editable = false

              if (c.konsolid_statuss === "MELNRAKSTS") {
                $scope.cons_editable = true
              }
              if (c.konsolid_statuss === null && all_done) {
                $scope.cons_editable = true
              }
              if (c.konsolid_statuss === "IESNIEDZAMS") {
                $scope.cons_editable = true
                $scope.cons_submittable = true
              }
              if (c.konsolid_statuss === "NORAIDITS") {
                $scope.cons_editable = true
              }
            } else {
              this.tabs[2].visible = false
            }

            let idx = 0
            this.tabs.forEach((t) => {
              if (!t.visible) return
              if (t.marked) {
                const n = idx
                $timeout(() => {
                  this.active_tab = n
                })
              }
              idx++
            })
          })

          $timeout(() => {
            $scope.$broadcast("rzSliderForceRender")
          })
        })
      }

      this.may_display = (statuss) => {
        if (statuss === "MELNRAKSTS") return false
        if (statuss === "IESNIEDZAMS") return false
        return true
      }

      $scope.reload = () => {
        $scope.dto = uuiData.record("petniecibas_pieteikums", $stateParams.id)
        $scope.dto.$promise.catch((e) => {
          Notification.error(e.data)
          $scope.dto.failed = true
          $scope.dto.exception = e.data
        })
        return $scope.dto.$promise.then($scope.reloadMe)
      }

      this.preparePpe = (me) => {
        return new PpExpertEvaluation(me)
      }

      this.cons_approve = () => {
        $http({
          method: "POST",
          url: "/data/pp_expert_cons_approve",
          data: { id: $stateParams.ekspertize_id },
        })
          .then($scope.reloadMe)
          .catch($scope.failing)
      }

      this.cons_reject = () => {
        // TODO: some reason
        const opts = {}
        const initial = {
          iemesls: "",
        }

        return Dialog.dialog("pages/dialogs/pp.expert.rejection.form.html", initial, opts, (p, action) => {
          if (action === "save") {
            return $http({
              method: "POST",
              url: "/data/pp_expert_cons_reject",
              data: { id: $stateParams.ekspertize_id, iemesls: p.iemesls },
            }).then(() => {
              Notification.success("Evaluation rejected")
              $scope.reloadMe()
            })
          }
        })
      }

      this.submit = () => {
        if (
          !confirm(
            "You are about to submit your evaluation. You will not be able to change it later. Proceed?"
          )
        ) {
          return
        }
        const ppe = this.preparePpe($scope.me)
        ppe.statuss = "IESNIEGTS"
        return ppe.$save(() => {
          $scope.reloadMe()
          if (ppe.statuss === "IESNIEGTS") {
            return Notification.success("Thank you! We received your evaluation!")
          }
          return Notification.error(
            "The evaluation could not be finalized, please check if all of the data is filled correctly."
          )
        }, $scope.failing)
      }

      this.save = () => {
        const ppe = this.preparePpe($scope.me)
        return ppe.$save(() => {
          $scope.reloadMe()
          return Notification.success("Saved!")
        }, $scope.failing)
      }

      this.cons_save = () => {
        const ppc = new PpExpertConsolidation($scope.cons)
        ppc.id = $stateParams.ekspertize_id
        if (ppc.excellence_score) {
          ppc.excellence_score *= 1.0
        }
        if (ppc.impact_score) {
          ppc.impact_score *= 1.0
        }
        if (ppc.implementation_score) {
          ppc.implementation_score *= 1.0
        }
        if (ppc.overall_score) {
          ppc.overall_score *= 1.0
        }
        return ppc.$save(() => {
          $scope.reloadMe()
          Notification.success("Saved!")
        }, $scope.failing)
      }

      this.cons_submit = () => {
        if (
          !confirm(
            "You are about to submit your consolidated evaluation. You will not be able to change it later. Proceed?"
          )
        ) {
          return
        }
        const ppe = new PpExpertConsolidation($scope.cons)
        ppe.id = $stateParams.ekspertize_id
        ppe.statuss = "IESNIEGTS"
        ppe.excellence_score *= 1.0
        ppe.impact_score *= 1.0
        ppe.implementation_score *= 1.0
        ppe.overall_score *= 1.0
        return ppe.$save(() => {
          $scope.reloadMe()
          return Notification.success("Thank you! We received your evaluation!")
        }, $scope.failing)
      }

      this.score = (k, v) => {
        if (!$scope.editable) return
        $scope.me[k] = 1.0 * v
      }

      this.rate = (k, v) => {
        if (!$scope.editable) return
        $scope.me[k] = v
      }

      this.cons_rate = (k, v) => {
        if (!$scope.cons_editable) return
        $scope.cons[k] = v
      }

      $scope.reload()

      return this
    }
  )
